import { combineReducers } from "redux";
import reducerClient from "./reducerClient";
import reducerItems from "./reducerItem";
import reducerUser from "./reducerUser";
import reducerDocument from "./reducerDocument";
import reducerInDocument from "./reducerInDocument";
import reducerPresupuesto from "./reducerPresupuesto";
import reducerLogin from "./reducerLogin";



const reducer = combineReducers({
    clientes: reducerClient,
    items: reducerItems,
    users: reducerUser,
    documents: reducerDocument,
    inDocuments: reducerInDocument,
    presupuesto: reducerPresupuesto,
    auth: reducerLogin
    
    
})

//console.log(reducer)
export default reducer;



